export default __webpack_public_path__ + "static/media/bg-sm-lines.08d5a29d.svg";